@if (loading() && !rows().length) {
  <div class="flex justify-center py-2xl">
    <lib-loader size="lg" />
  </div>
} @else {
  <ul class="flex flex-col transition-opacity" [class.opacity-50]="loading()">
    @for (row of rowViews(); track row.key) {
      <li>
        <button
          type="button"
          data-insight-bar-row
          class="grid w-full items-center gap-md rounded-md px-sm py-x-sm text-start text-sm transition-colors"
          [class]="rowClass()"
          [attr.title]="row.label + ': ' + row.value"
          [disabled]="!selectable()"
          (click)="select(row)">
          <span class="flex min-w-0 items-center gap-sm">
            <span
              class="size-2.5 shrink-0 rounded-sm"
              [style.background-color]="row.color"></span>
            <span class="truncate text-neutral-900">{{ row.label }}</span>
          </span>
          <span class="h-2 rounded-sm bg-neutral-100" aria-hidden="true">
            <span
              data-insight-bar
              class="block h-full rounded-sm"
              [style.width.%]="row.share"
              [style.min-width.px]="row.value ? 2 : 0"
              [style.background-color]="row.color"></span>
          </span>
          <span class="font-semibold text-neutral-900 tabular-nums">
            {{ row.value }}
          </span>
          <span
            class="justify-self-end rounded-full bg-neutral-100 px-sm py-px text-xs text-neutral-700 tabular-nums">
            {{ row.percentage }}
          </span>
          @if (selectable()) {
            <lib-chevron-down-icon
              [iconClass]="'size-4 text-neutral-400 -rotate-90 rtl:rotate-90'" />
          }
        </button>
      </li>
    }
  </ul>
}
